module.exports = "<div class=\"application\">\n    <div class=\"wrapper\">\n\n        <!-- views -->\n        <div class=\"views\">\n            <!-- *ngIf=\"!languageService.isChangingLanguage\"-->\n            <app-ranking></app-ranking>\n\n            <app-banner></app-banner>\n\n<!--\n            <img src=\"/assets/images/testcontent.png\" alt=\"\">\n            -->\n\n\n\n        </div>\n\n\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main